import { useTheme } from '@mui/material/styles';

interface Props {
  color: 'primary' | 'error' | 'success';
}

export const BackgroundGradient: React.FC<Props> = ({ color = 'primary' }) => {
  const theme = useTheme();

  const mainColor = theme.palette[color].main;
  const lighterColor = theme.palette[color].dark;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1920"
      height="502"
      fill="none"
      viewBox="0 0 1920 502"
      style={{ transition: 'all 1s' }}
    >
      <g clipPath="url(#clip0_11776_128604)" opacity="0.8">
        <g filter="url(#filter0_f_11776_128604)" opacity="0.3">
          <path
            fill="url(#paint0_linear_11776_128604)"
            fillRule="evenodd"
            d="M1516.45 318.144l-62.1 98.231-386.64-457.292 62.1-98.232 386.64 457.293z"
            clipRule="evenodd"
          ></path>
        </g>
        <g filter="url(#filter1_f_11776_128604)" opacity="0.3">
          <path
            fill="url(#paint1_linear_11776_128604)"
            fillRule="evenodd"
            d="M761.912 338.732l-38.048 78.051-386.152-457.7 38.048-78.052 386.152 457.701z"
            clipRule="evenodd"
          ></path>
        </g>
        <g filter="url(#filter2_f_11776_128604)" opacity="0.3">
          <path
            fill="url(#paint2_linear_11776_128604)"
            fillRule="evenodd"
            d="M1215.91 220.732l-38.05 78.051-386.148-457.701 38.048-78.051 386.15 457.701z"
            clipRule="evenodd"
          ></path>
        </g>
        <g filter="url(#filter3_f_11776_128604)" opacity="0.3">
          <path
            fill="url(#paint3_linear_11776_128604)"
            fillRule="evenodd"
            d="M1120.32 257.322L933.291 474.668l-508.543-597.15 187.025-217.346 508.547 597.15z"
            clipRule="evenodd"
          ></path>
        </g>
        <g filter="url(#filter4_f_11776_128604)" opacity="0.3">
          <path
            fill="url(#paint4_linear_11776_128604)"
            fillRule="evenodd"
            d="M632.605 355.488l-34.643 82.108L154.117-88.861l34.643-82.108 443.845 526.457z"
            clipRule="evenodd"
          ></path>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_11776_128604"
          width="648.737"
          height="755.524"
          x="967.712"
          y="-239.148"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          ></feBlend>
          <feGaussianBlur
            result="effect1_foregroundBlur_11776_128604"
            stdDeviation="50"
          ></feGaussianBlur>
        </filter>
        <filter
          id="filter1_f_11776_128604"
          width="624.199"
          height="735.752"
          x="237.712"
          y="-218.969"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          ></feBlend>
          <feGaussianBlur
            result="effect1_foregroundBlur_11776_128604"
            stdDeviation="50"
          ></feGaussianBlur>
        </filter>
        <filter
          id="filter2_f_11776_128604"
          width="624.199"
          height="735.752"
          x="691.712"
          y="-336.969"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          ></feBlend>
          <feGaussianBlur
            result="effect1_foregroundBlur_11776_128604"
            stdDeviation="50"
          ></feGaussianBlur>
        </filter>
        <filter
          id="filter3_f_11776_128604"
          width="895.568"
          height="1014.5"
          x="324.748"
          y="-439.828"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          ></feBlend>
          <feGaussianBlur
            result="effect1_foregroundBlur_11776_128604"
            stdDeviation="50"
          ></feGaussianBlur>
        </filter>
        <filter
          id="filter4_f_11776_128604"
          width="678.488"
          height="808.565"
          x="54.117"
          y="-270.969"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          ></feBlend>
          <feGaussianBlur
            result="effect1_foregroundBlur_11776_128604"
            stdDeviation="50"
          ></feGaussianBlur>
        </filter>
        <linearGradient
          id="paint0_linear_11776_128604"
          x1="1099.27"
          x2="1468.23"
          y1="-113.525"
          y2="326.183"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={mainColor} style={{ transition: 'all 1s' }}></stop>
          <stop
            offset="1"
            stopColor={mainColor}
            stopOpacity="0"
            style={{ transition: 'all 1s' }}
          ></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_11776_128604"
          x1="353.882"
          x2="722.84"
          y1="-100.611"
          y2="339.096"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={mainColor} style={{ transition: 'all 1s' }}></stop>
          <stop
            offset="1"
            stopColor={mainColor}
            stopOpacity="0"
            style={{ transition: 'all 1s' }}
          ></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_11776_128604"
          x1="807.882"
          x2="1176.84"
          y1="-218.611"
          y2="221.096"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={mainColor} style={{ transition: 'all 1s' }}></stop>
          <stop
            offset="1"
            stopColor={mainColor}
            stopOpacity="0"
            style={{ transition: 'all 1s' }}
          ></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_11776_128604"
          x1="533.72"
          x2="1020"
          y1="-274.334"
          y2="338"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            stopColor={lighterColor}
            style={{ transition: 'all 1s' }}
          ></stop>
          <stop
            offset="1"
            stopColor={lighterColor}
            stopOpacity="0"
            style={{ transition: 'all 1s' }}
          ></stop>
        </linearGradient>
        <linearGradient
          id="paint4_linear_11776_128604"
          x1="591.141"
          x2="166.882"
          y1="353.001"
          y2="-152.611"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={mainColor} style={{ transition: 'all 1s' }}></stop>
          <stop
            offset="1"
            stopColor={mainColor}
            stopOpacity="0"
            style={{ transition: 'all 1s' }}
          ></stop>
        </linearGradient>
        <clipPath id="clip0_11776_128604">
          <path fill="#fff" d="M0 0H1920V502H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};
